/* eslint-disable react/no-array-index-key */
import { InputNumber } from 'antd';
import DefaultMerchandise from '@assets/default-merchandise.svg';
import classes from '../index.module.css';

export default function chooseItem({
  item, onChange, quantity,
}) {
  const {
    lineItemId, imageUrl, itemTitle, variantTitle, sku, hasDiscount, actualPrice, price, maxQuantity,
  } = item;

  return (
    <section className={`${classes.merchandise}`} key={lineItemId}>
      <section className={classes.merchandise_content}>
        <section className={classes.item_info}>
          <img
            src={imageUrl || DefaultMerchandise}
            className={classes.item_img}
            alt=""
            onError={(e) => {
              const img = e.currentTarget;
              img.src = DefaultMerchandise;
              img.οnerrοr = null;
            }}
          />
          <section className={classes.info_block}>
            {itemTitle ? <section className={classes.title}>{itemTitle}</section> : null}
            {variantTitle ? <section className={classes.sub_title}>{variantTitle}</section> : null}
            {sku ? <section className={classes.sub_title}>{`SKU: ${sku}`}</section> : null}
          </section>
        </section>
        <section className={classes.price_block}>
          {actualPrice ? <section className={classes.price}>{`${actualPrice}`}</section> : null}
          {hasDiscount ? <section className={classes.actual_price}>{`${price}`}</section> : null}
        </section>
        <section>
          <InputNumber
            defaultValue={0}
            value={quantity}
            className={classes.quantity_input}
            min={0}
            max={maxQuantity}
            formatter={(value) => `${value} / ${maxQuantity}`}
            parser={(value) => value.replace(` / ${maxQuantity}`, '')}
            onChange={(e) => onChange(e, item)}
          />
        </section>
      </section>
    </section>
  );
}
